import { render, staticRenderFns } from "./ComposableTable.vue?vue&type=template&id=2a82a330&scoped=true&"
import script from "./ComposableTable.vue?vue&type=script&lang=js&"
export * from "./ComposableTable.vue?vue&type=script&lang=js&"
import style0 from "./ComposableTable.vue?vue&type=style&index=0&id=2a82a330&prod&lang=css&"
import style1 from "./ComposableTable.vue?vue&type=style&index=1&id=2a82a330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82a330",
  null
  
)

export default component.exports